export { default } from './EventPage'



// WEBPACK FOOTER //
// ./src/App/EventPage/index.js